import(/* webpackMode: "eager", webpackExports: ["CharterRemote"] */ "/var/www/light_of_empire_front/widgets/Charter/components/CharterRemote/CharterRemote.tsx");
